import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import cleanUrl from '../helpers/cleanUrl'
import Credits from './credits'
import Website from './website'
import Link from './link'

const Feature = ({
  slug = "",
  thumbnailPoster = "",
  thumbnailVideo = "",
  mainVideo = "",
  websiteUrl = "",
  description,
  publishedAt,
  credits,
  isHighlight
}) => {

	const [reveal, setReveal] = useState(!isHighlight)

	// useEffect(() => {
	// 	const timer = setTimeout(() => {
	// 		setReveal(true)
	// 	}, 100)
	// 	return () => clearTimeout(timer)
	// }, [])

  return (
    websiteUrl && (
      <figure className="feature">
        <Link to={`/features/${slug}`}>
          <div className="website" style={{
						transition: '0.3s',
						transform: reveal ? `scale(1)` : `scale(0.9)`
					}}>
            {isHighlight ? (
              <Website 
								src={mainVideo} 
								poster={thumbnailPoster} 
								websiteUrl={websiteUrl} 
								isHighlight={true} 
								setReveal={setReveal}
								key={`video-${slug}`} 
							/>
            ) : (
              <Website poster={thumbnailPoster} src={thumbnailVideo} websiteUrl={websiteUrl} key={`video-${slug}`} />
            )}
          </div>
        </Link>
        <figcaption>
          <h5>{publishedAt}</h5>
          {websiteUrl && (
            <Link className="link truncate" to={websiteUrl}>
              {cleanUrl(websiteUrl)}
            </Link>
          )}
          {description && <p className={isHighlight ? 'p3' : ''}>{description.description}</p>}
          {isHighlight && <h5 className="outer"><Credits credits={credits} slug={slug} /></h5>}
        </figcaption>
      </figure>
    )
  )
}

export default Feature

export const featureFragment = graphql`
  fragment Feature on ContentfulFeature {
    title
    contentful_id
    slug
    publishedAt(formatString: "D MMM YYYY")
    websiteUrl
    vimeoUrl
    mainVideo
    thumbnailPoster
    thumbnailVideo
    description {
      description
    }
    descriptionHtml: description {
  	  childMarkdownRemark {
        html
      }
  	}
    tags {
      name
    }
    credits {
			name
      website
      twitter
    }
  }
`
